var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Center, Flex, HStack, MenuItem, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Radio, RadioGroup, Spinner, Stack, Text, useToast, } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context-api/providers/auth";
export var ChooseProfile = function (_a) {
    var currentProfile = _a.currentProfile, userRockId = _a.userRockId, onClose = _a.onClose, isOpen = _a.isOpen, entityDatasource = _a.entityDatasource;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), profiles = _c[0], setProfiles = _c[1];
    var _d = useState(), selectedProfile = _d[0], setSelectedProfile = _d[1];
    var entityRockId = currentProfile.clientRockId || userRockId;
    var changeProfile = useContext(AuthContext).changeProfile;
    var toast = useToast();
    var chooseProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            changeProfile(selectedProfile.rockId, selectedProfile.type)
                .catch(function (e) {
                toast({
                    status: "error",
                    title: e.message,
                    duration: 3000,
                    isClosable: true,
                });
                setLoading(false);
            })
                .finally(function () { return setLoading(false); });
            return [2 /*return*/];
        });
    }); };
    var findCurrentProfile = function (rockId, type) {
        return profiles.find(function (profile) { return profile.rockId === rockId && profile.type === type; });
    };
    var isCurrentProfile = function (rockId, type) {
        return entityRockId === rockId && currentProfile.type === type;
    };
    var changeSelectedProfile = function (profile) {
        var _a = profile.split("*"), rockId = _a[0], type = _a[1];
        var currentProfile = findCurrentProfile(rockId, type);
        setSelectedProfile(currentProfile);
    };
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var profiles_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isOpen) return [3 /*break*/, 2];
                        return [4 /*yield*/, entityDatasource.getPersonas()];
                    case 1:
                        profiles_1 = _a.sent();
                        setProfiles(profiles_1);
                        setLoading(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [isOpen]);
    useEffect(function () {
        setSelectedProfile(findCurrentProfile(entityRockId, currentProfile.type));
    }, [profiles]);
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose },
        React.createElement(ModalOverlay, null,
            React.createElement(ModalContent, { minH: 300 },
                React.createElement(ModalHeader, { fontSize: "lg", fontWeight: "bold" }, "Select profile"),
                React.createElement(ModalCloseButton, null),
                React.createElement(ModalBody, { fontSize: "lg" },
                    loading && (React.createElement(Center, { py: "18" },
                        React.createElement(Spinner, { color: "blue.500" }))),
                    !loading && (React.createElement(RadioGroup, { onChange: function (profileSelected) {
                            return changeSelectedProfile(profileSelected);
                        }, value: (selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.rockId) + "*" + (selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.type) + "*" },
                        React.createElement(Stack, null, profiles
                            .sort(function (a, b) {
                            return isCurrentProfile(a.rockId, a.type) ? -1 : 1;
                        })
                            .map(function (profile, key) { return (React.createElement(MenuItem, { cursor: "pointer", key: key },
                            React.createElement(Radio, { value: profile.rockId + "*" + profile.type + "*", w: "100%" },
                                React.createElement(Flex, { align: "center", cursor: "pointer" },
                                    React.createElement(Text, { ml: "2", mr: "2", fontSize: "md", color: "black", fontWeight: "400" },
                                        profile.type !== "EMPLOYEE"
                                            ? profile.type
                                            : profile.name,
                                        isCurrentProfile(profile.rockId, profile.type) ? (React.createElement("span", { style: { color: "gray", paddingLeft: "3px" } }, "[current profile]")) : ("")))))); }))))),
                React.createElement(ModalFooter, null,
                    React.createElement(HStack, { spacing: 3 },
                        React.createElement(Button, { disabled: isCurrentProfile(selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.rockId, selectedProfile === null || selectedProfile === void 0 ? void 0 : selectedProfile.type), colorScheme: "blue", bg: "blue.500", onClick: chooseProfile }, "Change profile"),
                        React.createElement(Button, { onClick: onClose }, "Cancel")))))));
};
